import React from "react";

interface TypographyProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export function Typography({
  children,
  className = "",
  onClick,
  style,
}: TypographyProps) {
  return (
    <p className={className} onClick={onClick} style={style}>
      {children}
    </p>
  );
}
